module.exports = "/wp-content/plugins/farmacy/assets/js/images/touch_screen_icon-6cc3a40bde95f0310ef5c4d66c56a885.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/elo-app/img/touch_screen_icon.svg
 ** module id = 684
 ** module chunks = 1 76 89
 **/